module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e53862412"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c17_r1#d6e48",
      "id": "d7e48"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e53869412"
    }
  }, [_c('span', [_c('span', {
    staticClass: "dcap2 sgc-1",
    attrs: {
      "id": "d14e11165"
    }
  }, [_vm._v("N")]), _vm._v("ever has a book been more of a labor of love than "), _c('i', [_vm._v("Smitten")]), _vm._v("! The four of us have had the best time writing this book together.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e53888412"
    }
  }, [_c('span', [_vm._v("But we couldn’t have done it without lots of help. We are so blessed to have been able to do this project with Thomas Nelson. They caught the vision right from the start and entered into a partnership with us with great enthusiasm. A big hug and thanks to publisher Allen Arnold who was quick to tell us he wanted this project. And a big thank-you to our editor, Ami McConnell, who knows each one of us intimately and was able to make suggestions to bring our characters to life. Our team has worked hard on the project all along so we will be showing our gratitude with hugs and DeBrand truffles to Marketing Director Eric Mullett, Publicity Manager Katie Bond, cover designer Kristen Vasgaard, Marketing Specialist Ashley Schneider, Publicist Ruthie Harper, and editors Becky Monds, Jodi Hughes, Natalie Hanemann, and Amanda Bostic. Our terrific sales team is already hard at work too and we couldn’t do much without them! Love you all! And our agents, Karen Solem and Lee Hough, have been a huge help as we put together this very different story. Thanks, friends!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e53954412"
    }
  }, [_c('span', [_vm._v("A special thanks to Rick Acker for spending precious conference time sitting and brainstorming with us last year. He helped us flesh out our plot with some great suggestions. And our editor, L.B. Norton, was phenomenal on this project. She caught the inconsistencies that no one else could. And our families are always our backbones as we juggle life and career.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e53990413"
    }
  }, [_c('span', [_vm._v("Our biggest thank-you goes to God who brought the four of us together in a bond of unbreakable friendship. We are all so different, and yet one, in our love for Christ and for one another.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b60c1ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Hunt_9781401684952_epub_c65_r1.vue
// module id = 69
// module chunks = 0